// import React, { useState, useEffect, useMemo } from "react";
// import { useNavigate, Link } from "react-router-dom"; 
// import config from "../../../Common/Configurations/APIConfig";
// import apiService from "../../../Common/Configurations/APIService";
// import Header from "../../../Common/Layout/Header";
// import { useAuth } from "../../../Common/Configurations/AuthContext";
// import Modal from "react-bootstrap/Modal";
// import GroupTourChat from "./GroupTourChat";
// import GroupTourTravellers from "./GroupTourTravellers";
// import DefaultData from "../../../CompanyData/DefaultData";
// import CorporateTabs from "../../AllTabs/CorporateTabs";

// const initialFieldValues = {
//     fromLocation: "",
//     toLocation: "",
//     departureDate: new Date().toISOString().split('T')[0],
//     groupSize: "",
//     byFlight: false, byBus: false, byCar: false,
//     requirement: "",
// };

// const GroupTourAdmin = () => {
//     const { user, loading } = useAuth();
//     const navigate = useNavigate();

//     const [lists, setLists] = useState([]);
//     const [values, setValues] = useState(initialFieldValues);
//     const [errors, setErrors] = useState({});
//     const [addShow, setAddShow] = useState(false);
//     const [btnLoading, setBtnLoading] = useState(false);

//     // Split-Screen & View States
//     const [selectedTour, setSelectedTour] = useState(null);
//     const [viewType, setViewType] = useState(null); // 'chat' or 'travellers'
    
//     // Pagination States
//     const [totalPages, setTotalPages] = useState(0);
//     const [pageSize, setPageSize] = useState(50);
//     const [pageNumber, setPageNumber] = useState(1);
//     const [totalRecords, setTotalRecords] = useState(0);
    
//     // Requirement Popup States
//     const [reqShow, setReqShow] = useState(false);
//     const [reqContent, setReqContent] = useState("");

//     // Fetch Data using Admin Endpoint
//     const GetData = async () => {
//         try {
//             const url = `${config.GETGROUPTOURSBYPARENTCOMPANYID}?parentCompanyId=${DefaultData.DEFAULTCOMPANYID}`;
//             const res = await apiService.getAll(url, pageSize, pageNumber);
//             console.log("Fetched Admin Group Tours:", res);
//             if (res && res.data) {
//                 setLists(res.data);
//                 setPageNumber(res.pageNumber);
//                 setTotalPages(res.totalPages);
//                 setTotalRecords(res.totalRecords);

//                 if (selectedTour) {
//                     const updated = res.data.find(t => t.groupTourId === selectedTour.groupTourId);
//                     if (updated) setSelectedTour(updated);
//                 }
//             }
//         } catch (error) { 
//             console.error("Error fetching Admin Group Tours:", error); 
//         }
//     };

//     useEffect(() => { if (user && !loading) GetData(); }, [user, loading, pageNumber]);

//     // Pagination Handlers
//     const GetLastPageData = () => { setPageNumber(totalPages); };
//     const GetFirstPageData = () => { setPageNumber(1); };
//     const GetPageData = (number) => { setPageNumber(number); };

//     const renderPageNumbers = useMemo(() => {
//         return Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
//             <li className={`page-item ${pageNumber === number ? 'active' : ''}`} key={number} onClick={() => GetPageData(number)}>
//                 <Link className="page-link" to="#">{number}</Link>
//             </li>
//         ));
//     }, [totalPages, pageNumber]);

//     // UI Handlers
//     const handleInputChange = (e) => {
//         const { name, value, type, checked } = e.target;
//         setValues({ ...values, [name]: type === "checkbox" ? checked : value });
//     };

//     const handleRowClick = (item) => {
//         setSelectedTour(item);
//         setViewType('chat');
//     };

//     const handleOpenTravellers = (e, item) => {
//         e.stopPropagation();
//         setSelectedTour(item);
//         setViewType('travellers');
//     };

//     const handleCloseRightPanel = () => {
//         setSelectedTour(null);
//         setViewType(null);
//     };

//     const handleShowFullRequirement = (e, text) => {
//         e.stopPropagation();
//         setReqContent(text);
//         setReqShow(true);
//     };

//     const handleAddShow = () => { setValues(initialFieldValues); setAddShow(true); };
//     const handleAddClose = () => { setAddShow(false); setErrors({}); };

//     const validate = () => {
//         let temp = { 
//             fromLocation: values.fromLocation !== "", 
//             toLocation: values.toLocation !== "", 
//             groupSize: values.groupSize !== "" 
//         };
//         setErrors(temp);
//         return Object.values(temp).every((x) => x === true);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (validate()) {
//             setBtnLoading(true);
//             const modes = [];
//             if (values.byFlight) modes.push("By Flight");
//             if (values.byBus) modes.push("By Bus");
//             if (values.byCar) modes.push("By Car");
//             try {
//                 // When Admin creates, it uses Admin's cid and id
//                 await apiService.create(config.CREATEGROUPTOUR, { 
//                     ...values, travelModes: modes, companyId: user?.cid, userId: user?.id, status: "Pending" 
//                 });
//                 GetData();
//                 handleAddClose();
//             } finally { setBtnLoading(false); }
//         }
//     };

//     if (loading) return <p>Loading ...</p>;

//     return (
//         <div id="layout-wrapper">
//             <Header User={user} />
//             <div className="main-content">
//                 <div className="page-content">
//                     <div className="container-fluid">
//                         <div className="p-2">
//                 <CorporateTabs pageName="GROUPTOURREQUEST" />
//               </div>
//                         <div className="p-4 mb-4 shadow-sm" style={{ background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)', borderRadius: '15px' }}>
//                             <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
//                                 <div>
//                                     <h2 className="text-white fw-bold mb-1">Group Tour Management</h2>
//                                     <p className="text-white-50 fs-14 mb-0">Total Active Pipeline: <span className="text-warning fw-bold">{totalRecords} Inquiries</span></p>
//                                 </div>
//                                 <button className="btn btn-warning px-4 fw-bold shadow" onClick={handleAddShow}>
//                                     <i className="ri-add-circle-line me-1"></i> LOG MANUAL REQUEST
//                                 </button>
//                             </div>
//                         </div>

//                         {/* SPLIT SCREEN ROW */}
//                         <div className="row">
//                             {/* LEFT SIDE: LIST */}
//                             <div className={selectedTour ? "col-lg-6" : "col-lg-12"}>
//                                 <div className="card border-0 shadow-sm overflow-hidden">
//                                     <div className="card-header bg-white border-bottom">
//                                         <h6 className="mb-0 fw-bold text-muted">Request Pipeline</h6>
//                                     </div>
//                                     <div className="table-responsive">
//                                         <table className="table table-hover align-middle mb-0">
//                                             <thead className="table-light text-muted small text-uppercase">
//                                                 <tr>
//                                                     <th>Company</th>
//                                                     <th>Destination</th>
//                                                     <th>Pax</th>
//                                                     <th>Date</th>
//                                                     <th>Requirement</th>
//                                                     <th className="text-center">Action</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {lists.length > 0 ? lists.map((item, i) => (
//                                                     <tr key={i} onClick={() => handleRowClick(item)} style={{ cursor: 'pointer' }} className={selectedTour?.groupTourId === item.groupTourId ? "table-active border-start border-primary border-4" : ""}>
//                                                         <td><div className="fw-bold text-dark">{item.companyName}</div></td>
//                                                         <td className="fw-bold text-primary">{item.toLocation}</td>
//                                                         <td>{item.groupSize} Pax</td>
//                                                         <td>{new Date(item.departureDate).toLocaleDateString()}</td>
//                                                         <td>
//                                                             <div className="d-flex align-items-center gap-2">
//                                                                 <span className="text-truncate d-inline-block" style={{ maxWidth: "100px" }}>{item.requirement}</span>
//                                                                 <button className="btn btn-link p-0 text-muted" onClick={(e) => handleShowFullRequirement(e, item.requirement)}>
//                                                                     <i className="ri-eye-line fs-16"></i>
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                         <td className="text-center">
//                                                             <div className="hstack gap-2 justify-content-center">
//                                                                 <button className={`btn btn-sm ${selectedTour?.groupTourId === item.groupTourId && viewType === 'chat' ? "btn-primary" : "btn-soft-info"}`} onClick={(e) => { e.stopPropagation(); setSelectedTour(item); setViewType('chat'); }}>
//                                                                     Chat
//                                                                 </button>
//                                                                 <button className={`btn btn-sm ${selectedTour?.groupTourId === item.groupTourId && viewType === 'travellers' ? "btn-success" : "btn-soft-success"}`} onClick={(e) => handleOpenTravellers(e, item)}>
//                                                                     <i className="ri-user-add-line"></i> Travellers
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 )) : <tr><td colSpan="6" className="text-center py-4">No inquiries found.</td></tr>}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                     {/* PAGINATION */}
//                                     <div className="align-items-center mt-4 pt-2 justify-content-between d-flex p-3">
//                                         <div className="text-muted">Showing <span className="fw-semibold">{lists.length}</span> of <span className="fw-semibold">{totalRecords}</span> Results</div>
//                                         <ul className="pagination pagination-separated pagination-sm mb-0">
//                                             <li className={`page-item ${pageNumber === 1 ? "disabled" : ""}`} onClick={GetFirstPageData}><Link className="page-link" to="#">Previous</Link></li>
//                                             {renderPageNumbers}
//                                             <li className={`page-item ${pageNumber === totalPages ? "disabled" : ""}`} onClick={GetLastPageData}><Link className="page-link" to="#">Next</Link></li>
//                                         </ul>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* RIGHT SIDE PANEL (CHAT OR TRAVELLERS) */}
//                             {selectedTour && (
//                                 <div className="col-lg-6">
//                                     <div className="card shadow-lg border-0 h-100" style={{ minHeight: "600px" }}>
//                                         {viewType === 'chat' ? (
//                                             <GroupTourChat tour={selectedTour} user={user} onClose={handleCloseRightPanel} />
//                                         ) : (
//                                             <div className="d-flex flex-column h-100">
//                                                 <div className="card-header bg-success text-white d-flex justify-content-between py-3">
//                                                     <h6 className="mb-0 text-white fw-bold"><i className="ri-group-line me-2"></i> Travellers: {selectedTour.companyName}</h6>
//                                                     <button className="btn btn-close btn-close-white" onClick={handleCloseRightPanel}></button>
//                                                 </div>
//                                                 <div className="flex-grow-1 overflow-hidden">
//                                                     <GroupTourTravellers tour={selectedTour} user={user} onRefresh={GetData} />
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>

//                 {/* MODAL: CREATE INQUIRY (SAME AS B2E WITH PREVIEW) */}
//                 <Modal show={addShow} onHide={handleAddClose} centered size="xl" backdrop="static">
//                     <Modal.Header closeButton className="bg-light p-3 px-4">
//                         <Modal.Title className="fw-bold text-dark fs-18">Log Manual Group Itinerary</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body className="p-0">
//                         <form onSubmit={handleSubmit}>
//                             <div className="row g-0">
//                                 <div className="col-lg-7 p-4 border-end">
//                                     <div className="row g-3">
//                                         <div className="col-md-6">
//                                             <label className="form-label fw-bold small text-muted">FROM LOCATION</label>
//                                             <input type="text" name="fromLocation" className={`form-control ${errors.fromLocation === false ? "is-invalid" : ""}`} value={values.fromLocation} onChange={handleInputChange} />
//                                         </div>
//                                         <div className="col-md-6">
//                                             <label className="form-label fw-bold small text-muted">TO DESTINATION</label>
//                                             <input type="text" name="toLocation" className={`form-control ${errors.toLocation === false ? "is-invalid" : ""}`} value={values.toLocation} onChange={handleInputChange} />
//                                         </div>
//                                         <div className="col-md-6">
//                                             <label className="form-label fw-bold small text-muted">DEPARTURE DATE</label>
//                                             <input type="date" name="departureDate" className="form-control" value={values.departureDate} onChange={handleInputChange} />
//                                         </div>
//                                         <div className="col-md-6">
//                                             <label className="form-label fw-bold small text-muted">GROUP SIZE</label>
//                                             <input type="number" name="groupSize" className={`form-control ${errors.groupSize === false ? "is-invalid" : ""}`} value={values.groupSize} onChange={handleInputChange} />
//                                         </div>
//                                         <div className="col-12 mt-4">
//                                             <label className="form-label fw-bold small text-primary">SELECT TRAVEL MODES</label>
//                                             <div className="bg-light rounded p-3 d-flex flex-wrap gap-4 border">
//                                                 {['byFlight', 'byBus', 'byCar'].map(mode => (
//                                                     <div className="form-check form-check-inline" key={mode}>
//                                                         <input className="form-check-input" type="checkbox" name={mode} checked={values[mode]} onChange={handleInputChange} id={mode} />
//                                                         <label className="form-check-label fw-medium" htmlFor={mode}>{mode.replace('by', 'By ')}</label>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         </div>
//                                         <div className="col-12">
//                                             <label className="form-label fw-bold small text-muted">REQUIREMENT</label>
//                                             <textarea name="requirement" className="form-control" rows="4" value={values.requirement} onChange={handleInputChange}></textarea>
//                                         </div>
//                                     </div>
//                                     <div className="mt-4 text-end">
//                                         <button type="button" className="btn btn-link text-muted me-2" onClick={handleAddClose}>Discard</button>
//                                         <button type="submit" className="btn btn-primary px-5 fw-bold shadow" disabled={btnLoading}>
//                                             {btnLoading ? "Processing..." : "Create Request"}
//                                         </button>
//                                     </div>
//                                 </div>
//                                 <div className="col-lg-5 bg-light p-4 d-flex flex-column align-items-center justify-content-center">
//                                     <p className="text-muted small fw-bold mb-3 text-uppercase">Inquiry Preview</p>
//                                     <div className="card shadow-sm border-0 rounded-4 overflow-hidden w-100">
//                                         <div className="bg-success p-3 text-white text-center"><i className="ri-ticket-2-line fs-24"></i><h6 className="text-white mb-0 mt-1 fw-bold">Group Request</h6></div>
//                                         <div className="card-body p-4 bg-white border-bottom border-dashed">
//                                             <div className="row mb-3">
//                                                 <div className="col-6"><small className="text-muted d-block">FROM</small><span className="fw-bold">{values.fromLocation || "---"}</span></div>
//                                                 <div className="col-6"><small className="text-muted d-block">DESTINATION</small><span className="fw-bold text-success">{values.toLocation || "---"}</span></div>
//                                             </div>
//                                             <div className="row">
//                                                 <div className="col-6"><small className="text-muted d-block">DATE</small><span className="fw-bold small">{values.departureDate}</span></div>
//                                                 <div className="col-6"><small className="text-muted d-block">PAX</small><span className="fw-bold small">{values.groupSize || "0"} Pax</span></div>
//                                             </div>
//                                         </div>
//                                         <div className="p-3 bg-white" style={{ minHeight: '80px' }}><small className="text-muted d-block mb-1">NOTES</small><p className="small text-muted mb-0 italic">{values.requirement || "Describe needs..."}</p></div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </form>
//                     </Modal.Body>
//                 </Modal>

//                 {/* MODAL: FULL REQUIREMENT VIEW */}
//                 <Modal show={reqShow} onHide={() => setReqShow(false)} centered scrollable>
//                     <Modal.Header closeButton className="bg-soft-primary"><Modal.Title className="fs-16 fw-bold">Full Requirement</Modal.Title></Modal.Header>
//                     <Modal.Body className="bg-light-subtle p-4"><div className="p-3 bg-white border rounded shadow-sm"><p className="mb-0" style={{ whiteSpace: "pre-wrap" }}>{reqContent}</p></div></Modal.Body>
//                     <Modal.Footer><button className="btn btn-primary btn-sm px-4" onClick={() => setReqShow(false)}>Close</button></Modal.Footer>
//                 </Modal>

//             </div>
//         </div>
//     );
// };

// export default GroupTourAdmin;


import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, Link } from "react-router-dom"; 
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import GroupTourChat from "./GroupTourChat";
import GroupTourTravellers from "./GroupTourTravellers";
import DefaultData from "../../CompanyData/DefaultData";
import CorporateTabs from "../../Components/AllTabs/CorporateTabs";

const initialFieldValues = {
    fromLocation: "",
    toLocation: "",
    departureDate: new Date().toISOString().split('T')[0],
    groupSize: "",
    byFlight: false, byBus: false, byCar: false,
    requirement: "",
};

const GroupTourAdmin = () => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    const [lists, setLists] = useState([]);
    const [companyList, setCompanyList] = useState([]); // Company Dropdown State
    const [values, setValues] = useState(initialFieldValues);
    const [errors, setErrors] = useState({});
    const [addShow, setAddShow] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);

    // Split-Screen & View States
    const [selectedTour, setSelectedTour] = useState(null);
    const [viewType, setViewType] = useState(null); // 'chat' or 'travellers'
    
    // --- Filter States ---
    const [filterStatus, setFilterStatus] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [filterCompanyId, setFilterCompanyId] = useState(""); 

    // Pagination States
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    
    // Requirement Popup States
    const [reqShow, setReqShow] = useState(false);
    const [reqContent, setReqContent] = useState("");

    // --- Fetch Company List for Dropdown ---
    const GetCompanies = async () => {
        try {
            const res = await apiService.getAll(`${config.GETCORPORATESBYPARENTCOMPANYID}?parentCompanyId=${DefaultData.DEFAULTCOMPANYID}`);
            if (res) {
                setCompanyList(res);
            }
        } catch (error) {
            console.error("Error fetching companies:", error);
        }
    };

    // --- Fetch Data using Admin Endpoint with Filters ---
    const GetData = async (pageNo = 1) => {
        try {
            let url = `${config.GETGROUPTOURSBYPARENTCOMPANYID}?parentCompanyId=${DefaultData.DEFAULTCOMPANYID}`;

            // Append Optional Filters
            if (filterStatus) url += `&status=${filterStatus}`;
            if (fromDate) url += `&fromDate=${fromDate}`;
            if (toDate) url += `&toDate=${toDate}`;
            if (filterCompanyId) url += `&companyId=${filterCompanyId}`;

            const res = await apiService.getAll(url, pageSize, pageNo);
            
            if (res && res.data) {
                setLists(res.data);
                setPageNumber(res.pageNumber);
                setTotalPages(res.totalPages);
                setTotalRecords(res.totalRecords);

                // Update selected tour if it was open
                if (selectedTour) {
                    const updated = res.data.find(t => t.groupTourId === selectedTour.groupTourId);
                    if (updated) setSelectedTour(updated);
                }
            } else {
                setLists([]);
                setTotalRecords(0);
            }
        } catch (error) { 
            console.error("Error fetching Admin Group Tours:", error); 
            setLists([]);
        }
    };

    const handleReset = () => {
        setFilterStatus("");
        setFromDate("");
        setToDate("");
        setFilterCompanyId("");
        setPageNumber(1);
        // Direct call with fresh parameters
        GetData(1);
    };

    useEffect(() => { 
        if (user && !loading) {
            GetData(pageNumber); 
            GetCompanies();
        }
    }, [user, loading, pageNumber]);

    // Pagination Handlers
    const GetLastPageData = () => { setPageNumber(totalPages); };
    const GetFirstPageData = () => { setPageNumber(1); };
    const GetPageData = (number) => { setPageNumber(number); };

    const renderPageNumbers = useMemo(() => {
        return Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
            <li className={`page-item ${pageNumber === number ? 'active' : ''}`} key={number} onClick={() => GetPageData(number)}>
                <Link className="page-link" to="#">{number}</Link>
            </li>
        ));
    }, [totalPages, pageNumber]);

    // UI Handlers
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setValues({ ...values, [name]: type === "checkbox" ? checked : value });
    };

    const handleRowClick = (item) => {
        setSelectedTour(item);
        setViewType('chat');
    };

    const handleOpenTravellers = (e, item) => {
        e.stopPropagation();
        setSelectedTour(item);
        setViewType('travellers');
    };

    const handleCloseRightPanel = () => {
        setSelectedTour(null);
        setViewType(null);
    };

    const handleShowFullRequirement = (e, text) => {
        e.stopPropagation();
        setReqContent(text);
        setReqShow(true);
    };

    const handleAddShow = () => { setValues(initialFieldValues); setAddShow(true); };
    const handleAddClose = () => { setAddShow(false); setErrors({}); };

    const validate = () => {
        let temp = { 
            fromLocation: values.fromLocation !== "", 
            toLocation: values.toLocation !== "", 
            groupSize: values.groupSize !== "" 
        };
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnLoading(true);
            const modes = [];
            if (values.byFlight) modes.push("By Flight");
            if (values.byBus) modes.push("By Bus");
            if (values.byCar) modes.push("By Car");
            try {
                await apiService.create(config.CREATEGROUPTOUR, { 
                    ...values, travelModes: modes, companyId: user?.cid, userId: user?.id, status: "Pending" 
                });
                GetData(1);
                handleAddClose();
            } finally { setBtnLoading(false); }
        }
    };

    if (loading) return <p>Loading ...</p>;

    return (
        <div id="layout-wrapper">
            <Header User={user} />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="p-2">
                            <CorporateTabs pageName="GROUPTOURREQUEST" />
                        </div>

                        {/* HEADER BANNER */}
                       <div className="d-flex justify-content-end mb-4">
    <button 
        className="btn btn-warning px-4 fw-bold shadow" 
        onClick={handleAddShow}
    >
        <i className="ri-add-circle-line me-1"></i> LOG MANUAL REQUEST
    </button>
</div>


                        {/* FILTER SECTION */}
                        <div className="card border-0 shadow-sm mb-4">
                            <div className="card-body">
                                <div className="row g-3 align-items-end">
                                    <div className="col-md-3">
                                        <label className="form-label small fw-bold text-muted text-uppercase">Company</label>
                                        <select className="form-select" value={filterCompanyId} onChange={(e) => setFilterCompanyId(e.target.value)}>
                                            <option value="">All Companies</option>
                                            {companyList.map((comp) => (
                                                <option key={comp.companyId} value={comp.companyId}>{comp.companyName}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label small fw-bold text-muted text-uppercase">Status</label>
                                        <select className="form-select" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                                            <option value="">All Status</option>
                                            <option value="Pending">Pending</option>
                                            <option value="Confirmed">Confirmed</option>
                                            <option value="Cancelled">Cancelled</option>
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label small fw-bold text-muted text-uppercase">From Date</label>
                                        <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label small fw-bold text-muted text-uppercase">To Date</label>
                                        <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                                    </div>
                                    <div className="col-md-3 text-end">
                                        <button className="btn btn-primary px-3 me-2" onClick={() => { setPageNumber(1); GetData(1); }}>
                                            <i className="ri-search-line me-1"></i> Search
                                        </button>
                                        <button className="btn btn-soft-danger px-3" onClick={handleReset}>
                                            <i className="ri-refresh-line me-1"></i> Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* SPLIT SCREEN ROW */}
                        <div className="row">
                            <div className={selectedTour ? "col-lg-6" : "col-lg-12"}>
                                <div className="card border-0 shadow-sm overflow-hidden">
                                    <div className="card-header bg-white border-bottom">
                                        <h6 className="mb-0 fw-bold text-muted">Request Pipeline</h6>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-hover align-middle mb-0">
                                            <thead className="table-light text-muted small text-uppercase">
                                                <tr>
                                                    <th>Company</th>
                                                    <th>Destination</th>
                                                    <th>Pax</th>
                                                    <th>Date</th>
                                                    <th>Requirement</th>
                                                    <th className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lists.length > 0 ? lists.map((item, i) => (
                                                    <tr key={i} onClick={() => handleRowClick(item)} style={{ cursor: 'pointer' }} className={selectedTour?.groupTourId === item.groupTourId ? "table-active border-start border-primary border-4" : ""}>
                                                        <td><div className="fw-bold text-dark">{item.companyName}</div></td>
                                                        <td className="fw-bold text-primary">{item.toLocation}</td>
                                                        <td>{item.groupSize} Pax</td>
                                                        <td>{new Date(item.departureDate).toLocaleDateString()}</td>
                                                        <td>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <span className="text-truncate d-inline-block" style={{ maxWidth: "100px" }}>{item.requirement}</span>
                                                                <button className="btn btn-link p-0 text-muted" onClick={(e) => handleShowFullRequirement(e, item.requirement)}>
                                                                    <i className="ri-eye-line fs-16"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td className="text-center">
                                                            <div className="hstack gap-2 justify-content-center">
                                                                <button className={`btn btn-sm ${selectedTour?.groupTourId === item.groupTourId && viewType === 'chat' ? "btn-primary" : "btn-soft-info"}`} onClick={(e) => { e.stopPropagation(); setSelectedTour(item); setViewType('chat'); }}>
                                                                    Chat
                                                                </button>
                                                                <button className={`btn btn-sm ${selectedTour?.groupTourId === item.groupTourId && viewType === 'travellers' ? "btn-success" : "btn-soft-success"}`} onClick={(e) => handleOpenTravellers(e, item)}>
                                                                    <i className="ri-user-add-line"></i> Travellers
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )) : (
                                                    <tr><td colSpan="6" className="text-center py-4">No records found for the selected filters.</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* PAGINATION */}
                                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex p-3">
                                        <div className="text-muted">Showing <span className="fw-semibold">{lists.length}</span> of <span className="fw-semibold">{totalRecords}</span> Results</div>
                                        <ul className="pagination pagination-separated pagination-sm mb-0">
                                            <li className={`page-item ${pageNumber === 1 ? "disabled" : ""}`} onClick={GetFirstPageData}><Link className="page-link" to="#">Previous</Link></li>
                                            {renderPageNumbers}
                                            <li className={`page-item ${pageNumber === totalPages ? "disabled" : ""}`} onClick={GetLastPageData}><Link className="page-link" to="#">Next</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* RIGHT SIDE PANEL */}
                            {selectedTour && (
                                <div className="col-lg-6">
                                    <div className="card shadow-lg border-0 h-100" style={{ minHeight: "600px" }}>
                                        {viewType === 'chat' ? (
                                            <GroupTourChat tour={selectedTour} user={user} onClose={handleCloseRightPanel} />
                                        ) : (
                                            <div className="d-flex flex-column h-100">
                                                <div className="card-header bg-success text-white d-flex justify-content-between py-3">
                                                    <h6 className="mb-0 text-white fw-bold"><i className="ri-group-line me-2"></i> Travellers: {selectedTour.companyName}</h6>
                                                    <button className="btn btn-close btn-close-white" onClick={handleCloseRightPanel}></button>
                                                </div>
                                                <div className="flex-grow-1 overflow-hidden">
                                                    <GroupTourTravellers tour={selectedTour} user={user} onRefresh={GetData} />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* MODAL: CREATE INQUIRY */}
                <Modal show={addShow} onHide={handleAddClose} centered size="xl" backdrop="static">
                    <Modal.Header closeButton className="bg-light p-3 px-4">
                        <Modal.Title className="fw-bold text-dark fs-18">Log Manual Group Itinerary</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-0">
                        <form onSubmit={handleSubmit}>
                            <div className="row g-0">
                                <div className="col-lg-7 p-4 border-end">
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold small text-muted">FROM LOCATION</label>
                                            <input type="text" name="fromLocation" className={`form-control ${errors.fromLocation === false ? "is-invalid" : ""}`} value={values.fromLocation} onChange={handleInputChange} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold small text-muted">TO DESTINATION</label>
                                            <input type="text" name="toLocation" className={`form-control ${errors.toLocation === false ? "is-invalid" : ""}`} value={values.toLocation} onChange={handleInputChange} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold small text-muted">DEPARTURE DATE</label>
                                            <input type="date" name="departureDate" className="form-control" value={values.departureDate} onChange={handleInputChange} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-bold small text-muted">GROUP SIZE</label>
                                            <input type="number" name="groupSize" className={`form-control ${errors.groupSize === false ? "is-invalid" : ""}`} value={values.groupSize} onChange={handleInputChange} />
                                        </div>
                                        <div className="col-12 mt-4">
                                            <label className="form-label fw-bold small text-primary">SELECT TRAVEL MODES</label>
                                            <div className="bg-light rounded p-3 d-flex flex-wrap gap-4 border">
                                                {['byFlight', 'byBus', 'byCar'].map(mode => (
                                                    <div className="form-check form-check-inline" key={mode}>
                                                        <input className="form-check-input" type="checkbox" name={mode} checked={values[mode]} onChange={handleInputChange} id={mode} />
                                                        <label className="form-check-label fw-medium" htmlFor={mode}>{mode.replace('by', 'By ')}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label fw-bold small text-muted">REQUIREMENT</label>
                                            <textarea name="requirement" className="form-control" rows="4" value={values.requirement} onChange={handleInputChange}></textarea>
                                        </div>
                                    </div>
                                    <div className="mt-4 text-end">
                                        <button type="button" className="btn btn-link text-muted me-2" onClick={handleAddClose}>Discard</button>
                                        <button type="submit" className="btn btn-primary px-5 fw-bold shadow" disabled={btnLoading}>
                                            {btnLoading ? "Processing..." : "Create Request"}
                                        </button>
                                    </div>
                                </div>
                                <div className="col-lg-5 bg-light p-4 d-flex flex-column align-items-center justify-content-center">
                                    <p className="text-muted small fw-bold mb-3 text-uppercase">Inquiry Preview</p>
                                    <div className="card shadow-sm border-0 rounded-4 overflow-hidden w-100">
                                        <div className="bg-success p-3 text-white text-center"><i className="ri-ticket-2-line fs-24"></i><h6 className="text-white mb-0 mt-1 fw-bold">Group Request</h6></div>
                                        <div className="card-body p-4 bg-white border-bottom border-dashed">
                                            <div className="row mb-3">
                                                <div className="col-6"><small className="text-muted d-block">FROM</small><span className="fw-bold">{values.fromLocation || "---"}</span></div>
                                                <div className="col-6"><small className="text-muted d-block">DESTINATION</small><span className="fw-bold text-success">{values.toLocation || "---"}</span></div>
                                            </div>
                                            <div className="row">
                                                <div className="col-6"><small className="text-muted d-block">DATE</small><span className="fw-bold small">{values.departureDate}</span></div>
                                                <div className="col-6"><small className="text-muted d-block">PAX</small><span className="fw-bold small">{values.groupSize || "0"} Pax</span></div>
                                            </div>
                                        </div>
                                        <div className="p-3 bg-white" style={{ minHeight: '80px' }}><small className="text-muted d-block mb-1">NOTES</small><p className="small text-muted mb-0 italic">{values.requirement || "Describe needs..."}</p></div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>

                {/* MODAL: FULL REQUIREMENT VIEW */}
                <Modal show={reqShow} onHide={() => setReqShow(false)} centered scrollable>
                    <Modal.Header closeButton className="bg-soft-primary"><Modal.Title className="fs-16 fw-bold">Full Requirement</Modal.Title></Modal.Header>
                    <Modal.Body className="bg-light-subtle p-4"><div className="p-3 bg-white border rounded shadow-sm"><p className="mb-0" style={{ whiteSpace: "pre-wrap" }}>{reqContent}</p></div></Modal.Body>
                    <Modal.Footer><button className="btn btn-primary btn-sm px-4" onClick={() => setReqShow(false)}>Close</button></Modal.Footer>
                </Modal>

            </div>
        </div>
    );
};

export default GroupTourAdmin;